import type { AutocompletePlugin } from '@algolia/autocomplete-core'
import { sendAnalytics } from '@audio-network/analytics'

import { SetIndexUiState } from '@/components/pages/search/SearchBox/SearchBox.types'
import type { AutocompleteFetcher } from '@/utils/algolia/autocomplete'
import { shouldShowCuratedAutocompleteSections } from '@/utils/algolia/autocomplete/utils'
import type { FacetHit } from '@/utils/algolia/autocompleteHitTypes'

export const facetsPlugin = (
	setIndexUiState: SetIndexUiState,
	refineSearch: (query: string) => void,
	fetchAutocomplete: AutocompleteFetcher
): AutocompletePlugin<FacetHit> => {
	return {
		name: 'facetsPlugin',
		getSources({ query }) {
			if (!shouldShowCuratedAutocompleteSections(query)) {
				return []
			}

			return [
				{
					sourceId: 'facetsSource',
					/** Empty: Don't add query when clicking on a facet */
					getItemInputValue() {
						return ''
					},
					getItems() {
						return fetchAutocomplete(query).then((b) => b.facetHits)
					},
					onSelect({ item, setIsOpen }) {
						refineSearch('')
						setIndexUiState((prevIndexUiState) => {
							const updatedFacetValues = [
								...new Set([
									...(prevIndexUiState.refinementList?.[item.facetType] ?? []),
									item.label,
								]),
							]
							return {
								...prevIndexUiState,
								query: '',
								refinementList: {
									...prevIndexUiState.refinementList,
									[item.facetType]: updatedFacetValues,
								},
							}
						})
						setIsOpen(false)

						sendAnalytics({
							noun: 'Typeahead',
							pastTenseVerb: 'Submitted',
							eventParameters: {
								FacetName: item.label,
								Type: 'Facet',
							},
						})
					},
				},
			]
		},
	}
}
